jQuery(function ($) {

  $('.js-tag-section').each(function () {

    const $section = $(this);
    const $grid    = $section.find('.js-articleMore');
    const $items   = $section.find('.js-tag-item');
    const $tags    = $section.find('.p-seminarTag li');
    const $button  = $section.find('.c-btn-list');

    const hasButton = $button.length > 0;

    const initialVisible = 9;
    const loadMoreCount  = 9;

    let visibleCount = hasButton ? initialVisible : $items.length;
    let isExpandedAll = false;

    let $filteredItems = $items;

    function updateList(animate = false) {
      $items.hide();

      const $visibleItems = $filteredItems.slice(0, visibleCount);

      if (animate) {
        $visibleItems.each(function (i) {
          $(this).delay(i * 80).fadeIn(300);
        });
      } else {
        $visibleItems.show();
      }

      if (hasButton) {
        if ($filteredItems.length <= initialVisible) {
          $button.hide();
        } else {
          $button.show();
        }
        if (visibleCount >= $filteredItems.length) {
          isExpandedAll = true;
          $button.text('閉じる').addClass('is-open');
        } else {
          isExpandedAll = false;
          $button.text('もっと見る').removeClass('is-open');
        }
      }
    }

    // 初期表示
    updateList();

    // もっと見る（ボタンがあるときだけ）
    if (hasButton) {
      $button.on('click', function (e) {
        e.preventDefault();

        if (isExpandedAll) {
          visibleCount = initialVisible;

          $('html, body').animate({
            scrollTop: $grid.offset().top - 100
          }, 400);

          updateList();
        } else {
          visibleCount += loadMoreCount;

          if (visibleCount > $filteredItems.length) {
            visibleCount = $filteredItems.length;
          }

          updateList(true);
        }
      });
    }

    // タグフィルター
    $tags.on('click', function () {
      const $this = $(this);

      $tags.removeClass('is-current');
      $this.addClass('is-current');

      // 件数リセット
      visibleCount = hasButton ? initialVisible : $items.length;

      // すべて
      if ($this.hasClass('js-tag-all')) {
        $filteredItems = $items;
        updateList();
        return;
      }

      // クラス取得（js-tag-xxx）
      const className = $this.attr('class')
        .split(' ')
        .find(c => c.indexOf('js-tag-') === 0);

      // フィルター
      $filteredItems = $items.filter('.' + className);

      updateList();
    });

  });

});
